<template>
    <div class="animated fadeIn">
        <CCard>
            <CCardHeader><font-awesome-icon icon="paperclip"/> AI Model
            </CCardHeader>
            <CCardBody>
                <CTabs :active-tab="my_tab" @update:activeTab="changeTab">
                    <br>  
                    <CTab>
                        <template slot="title">
                            Active AI Model/s <CBadge color="success">( {{ [...new Set(am_lists_active.map((item) => item.name))].length }} )</CBadge>
                        </template>
                        <CRow>
                            <CCol lg="12">
                                <CDataTable
                                    :items="am_lists_active"
                                    :fields="am_lists_fields"
                                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                                    :items-per-page="10"
                                    border
                                    items-per-page-select
                                    sorter
                                    pagination
                                    hover
                                    :loading="this.table_loading"
                                >
                                <template slot="no-items-view" v-if="this.table_loading">
                                    <center>
                                        <CSpinner
                                            style="width:4rem;height:4rem;"
                                            color="info"
                                        />
                                    </center>
                                </template>
                                <template #icon="{item}">
                                    <td>
                                        <center>
                                            <CIcon :name="item.icon" size="xl" />
                                        </center>
                                    </td>
                                </template>
                                <template #name="{item}">
                                    <td :title="item.name">             
                                        {{item.name.length > 30 ? item.name.substring(0, 30) + '...' :  item.name}}
                                    </td>
                                </template>
                                <template #provider="{item}">
                                    <td :title="item.provider">             
                                        {{item.provider > 30 ? item.provider.substring(0, 30) + '...' :  item.provider}}
                                    </td>
                                </template>
                                <template #created_at="{item}">
                                    <td>
                                        {{ item.created_at }}
                                    </td>
                                </template>
                                <template #Action="{item}">
                                    <td>
                                        <router-link :to="{path: `/${$store.getters['getOrganizationName']}/drs/ai-model/${item.id}`}">
                                            <CButton 

                                                color="info" 
                                                shape="pill" 
                                                size="sm"
                                            >
                                                <font-awesome-icon icon="cog"/> Manage
                                            </CButton>
                                        </router-link>
                                    </td>
                                </template>
                                </CDataTable>
                            </CCol>
                        </CRow>
                    </CTab>
                    <CTab>
                        <template slot="title">
                            Inactive AI Model/s <CBadge color="danger">( {{ [...new Set(am_lists_inactive.map((item) => item.name))].length }} )</CBadge>
                        </template>
                        <CRow>
                            <CCol lg="12">
                                <CDataTable
                                    :items="am_lists_inactive"
                                    :fields="am_lists_fields"
                                    :table-filter="{ placeholder: 'Your text here.', label: 'Search:'}"
                                    :items-per-page="10"
                                    border
                                    items-per-page-select
                                    sorter
                                    pagination
                                    :loading="this.table_loading"
                                    hover
                                >
                                    <template slot="no-items-view" v-if="this.table_loading">
                                        <center>
                                            <CSpinner
                                                style="width:4rem;height:4rem;"
                                                color="info"
                                            />
                                        </center>
                                    </template>
                                <template #name="{item}">
                                    <td :title="item.name">             
                                        {{item.name.length > 30 ? item.name.substring(0, 30) + '...' :  item.name}}
                                    </td>
                                </template>
                                <template #provider="{item}">
                                    <td :title="item.provider">             
                                        {{item.provider > 30 ? item.provider.substring(0, 30) + '...' :  item.provider}}
                                    </td>
                                </template>
                                    <template #updated_at="{item}">
                                        <td>
                                            <small>{{ item.updated_at }}</small>
                                        </td>
                                    </template>
                                    <template #Action="{item}">
                                        <td >
                                            <template v-if="$store.getters['can']('restore-ai-model')">
                                                <CButton 
                                                        size="sm"
                                                        shape="pill"
                                                        color="success" 
                                                        :disabled="restoring ? (item.id == restoring_id ? true : false) : false"
                                                        @click="restore(item)"
                                                    >

                                                    <font-awesome-icon :icon="restoring ? (item.id == restoring_id ? 'circle-notch' : 'trash-restore') : 'trash-restore'" 
                                                                :pulse="restoring ? (item.id == restoring_id ? true : false) : false"/> Restore
                                                </CButton>
                                            </template>
                                            <template v-else>
                                                <i><b>No permission to restore.</b></i>
                                            </template>
                                        </td>
                                    </template>  
                                </CDataTable>
                            </CCol>
                        </CRow>
                    </CTab>
                </CTabs>




            </CCardBody>
        </CCard>   
    </div>
</template>
<script>
// import CHideShowBtn from '../../components/CHideShowBtn'
export default {
    name: 'AMLists',
    // components:{
    //     CHideShowBtn
    // },
    data() {
        return {
            table_loading: true,
            am_lists_all: [],
            restoring: false,
            my_tab: 0,
            restoring_id: null,
        }
    },
    created() {
        this.getAIModels();
        this.$emit('activeTab', 0);
    },
    computed: {
        am_lists_active: function() {
            return this.am_lists_all.filter((item) => item.deleted_at == null);
        },

        am_lists_inactive: function() {
            return this.am_lists_all.filter((item) => item.deleted_at != null);
        },

        am_lists_fields: function () {
            let custom_fields= [
                { key: 'name', label: 'Name'},
                { key: 'provider', label: 'Provider' },
            ]
            
            if(this.my_tab) {
                custom_fields.push({ key: 'updated_at', label: 'Inactivity Date' })
            } else {
                custom_fields.push({ key: 'created_at', label: 'Date Added' })
            }

            if(this.$store.getters.can('view-ai-model')) {
                custom_fields.push({ key: 'Action', sorter: false})
            }
            return custom_fields;
        }
    },
    methods: {
        changeTab: function (item) {
            this.my_tab = item
        },      
        restore: function (item) {
            this.restoring = true
            this.restoring_id = item.id;
            this.$Progress.start()
                axios.post('/drs/ai-model/restore/' + item.id, {validateStatus: () => true})
                .then(response => {
                if(response.status == 200) {
                    this.$swal({
                        toast: true,
                        position: 'top-right',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: `${item.name} has been restored.`,
                        showConfirmButton: false,
                        timerProgressBar: true,
                    })
                    this.am_lists_all.filter(obj => obj.id == item.id)[0].deleted_at = null;
                    this.$Progress.finish() 
                }
            })
        },
        getAIModels: function () {
            this.$Progress.start()
            axios.get('/drs/ai-model/list', {validateStatus: () => true})
            .then(response => {
                if(response.status == 200) {
                    this.am_lists_all = []
                    for (let i = 0; i < response.data.data.length; i++) {
                        const item = response.data.data[i];
                        let row = {
                            id: item.id,
                            name: item.name,
                            provider: item.provider,
                            deleted_at: item.deleted_at,
                            created_at: this.changeDateFormatV2(item.created_at),
                            updated_at: this.changeDateFormat(item.updated_at)
                        }
                        
                        this.am_lists_all.push(row)
                    }
                    this.table_loading = false;
                    this.$Progress.finish()
                }
            })
        },
    },
}
</script>